import type { CmmdUserForgeAutomationRun } from "@cmmd-forge/contracts";
import { buildCmmdRuntimeEnvironmentId } from "../../environments/cmmdRuntimeEnvironmentId";

import type { LocalAutomationRun } from "./localAutomationClient";

export interface AutomationDisplayRun {
  readonly id: string;
  readonly status: string;
  readonly trigger: string;
  readonly updatedAt: string;
  readonly threadId: string | null;
  readonly environmentId: string | null;
  // Server-recorded failure sentence (#3397); cloud runs carry none today.
  readonly error: string | null;
}

function stringField(record: Record<string, unknown>, key: string): string | null {
  const value = record[key];
  return typeof value === "string" && value.trim().length > 0 ? value : null;
}

export function cloudDisplayRun(row: CmmdUserForgeAutomationRun): AutomationDisplayRun {
  const targetRef = row.run.targetRef;
  const runtimeId = stringField(targetRef, "runtimeId");
  return {
    id: String(row.run.id),
    status: row.run.status,
    trigger: row.run.sourceType === "manual" ? "Manual" : "Schedule",
    updatedAt: row.run.updatedAt,
    threadId: stringField(targetRef, "threadId"),
    environmentId: runtimeId ? buildCmmdRuntimeEnvironmentId(runtimeId) : null,
    error: null,
  };
}

export function localDisplayRun(
  run: LocalAutomationRun,
  environmentId: string | null,
): AutomationDisplayRun {
  return {
    id: run.id,
    status: run.status,
    trigger: run.triggerType === "manual" ? "Manual" : "Schedule",
    updatedAt: run.updatedAt,
    threadId: run.threadId,
    environmentId,
    error: run.error,
  };
}
